import _ from "lodash"

export type TDebounceCallback<T> = (arg:T) => void

export default class Debounce<T> {
    private _cb : TDebounceCallback<T>[] = []
    private _delay : number
    private _timeout : any
    private _arg : T|undefined
    private _callback : ()=>void

    constructor(delay:number){
        this._delay = delay
        this._callback = this.callback.bind(this)
    }

    subscribe(cb:TDebounceCallback<T>){
        this._cb.push(cb)
        return this
    }
    unsubscribe(cb:TDebounceCallback<T>){
        _.pull(this._cb, cb)
        if (this._cb.length==0 && this._timeout) {
            clearTimeout(this._timeout)
            this._timeout = null
        }
        return this
    }
    next(arg:T) {
        if (this._timeout) clearTimeout(this._timeout)
        this._arg = arg
        this._timeout = setTimeout(this._callback, this._delay)
    }
    callback(){
        this._timeout = null
        for(const cb of this._cb) cb(this._arg!)
    }
}